import * as React from 'react';
import { SVGProps } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <g clipPath="url(#a)">
      <path
        fill="currentColor"
        d="M24 12.06c0-6.6-5.4-12-12-12s-12 5.4-12 12c0 6 4.44 10.92 10.08 11.88v-8.4h-3v-3.48h3.12V9.42c-.12-3 1.68-4.68 4.44-4.68 1.32 0 2.64.24 2.64.24v2.88h-1.44c-1.44 0-1.92.96-1.92 1.92v2.28h3.36l-.48 3.48h-2.76v8.4c5.52-.96 9.96-5.88 9.96-11.88Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export { SvgComponent as Facebook };
